import PostHogManager from '@widgets/posthog-manager';

const storeActiveAccountId = id => localStorage.setItem('activeAccountId', String(id));

export const setUserInLocalStorage = user => {
    const userFromLS = JSON.parse(localStorage.getItem('user'));
    localStorage.setItem('user', JSON.stringify({ ...userFromLS, ...user, token: user?.token || userFromLS?.token }));
    if (Number.isInteger(user?.accountId) && user.accountId > 0) {
        storeActiveAccountId(user.accountId);
    }
};

export const getTokenFromStoredUser = storedUser => {
    try {
        return JSON.parse(storedUser ?? 'null')?.token ?? null;
    } catch {
        return null;
    }
};

export const getStoredToken = () => getTokenFromStoredUser(localStorage.getItem('user'));

export const getTokenClaims = token => {
    try {
        return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    } catch {
        return null;
    }
};

export const getSessionIdentity = token => {
    const claims = token ? getTokenClaims(token) : null;
    return claims ? `${claims.id}:${claims.imp ?? ''}` : '';
};

export const getActiveAccountId = () => {
    const stored = localStorage.getItem('activeAccountId');
    return stored ? Number(stored) : null;
};

export const setActiveAccountId = id => {
    storeActiveAccountId(id);
    PostHogManager.setAccount(id);
};
